
import { useState } from 'react';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-100 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
              Territorio360
            </h1>
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <button 
                onClick={() => scrollToSection('inicio')}
                className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Inicio
              </button>
              <button 
                onClick={() => scrollToSection('quienes-somos')}
                className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Quiénes Somos
              </button>
              <button 
                onClick={() => scrollToSection('que-hacemos')}
                className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Qué Hacemos
              </button>
              <button 
                onClick={() => scrollToSection('red-territorio360')}
                className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Red
              </button>
              <button 
                onClick={() => scrollToSection('financiacion')}
                className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Financiación
              </button>
              <button 
                onClick={() => scrollToSection('proyectos')}
                className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Proyectos
              </button>
              <button 
                onClick={() => scrollToSection('contacto')}
                className="bg-teal-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                Contacto
              </button>
            </div>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-teal-600 p-2 cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-gray-100">
              <button 
                onClick={() => scrollToSection('inicio')}
                className="block text-gray-700 hover:text-teal-600 px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Inicio
              </button>
              <button 
                onClick={() => scrollToSection('quienes-somos')}
                className="block text-gray-700 hover:text-teal-600 px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Quiénes Somos
              </button>
              <button 
                onClick={() => scrollToSection('que-hacemos')}
                className="block text-gray-700 hover:text-teal-600 px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Qué Hacemos
              </button>
              <button 
                onClick={() => scrollToSection('red-territorio360')}
                className="block text-gray-700 hover:text-teal-600 px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Red
              </button>
              <button 
                onClick={() => scrollToSection('financiacion')}
                className="block text-gray-700 hover:text-teal-600 px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Financiación
              </button>
              <button 
                onClick={() => scrollToSection('proyectos')}
                className="block text-gray-700 hover:text-teal-600 px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Proyectos
              </button>
              <button 
                onClick={() => scrollToSection('contacto')}
                className="block bg-teal-600 text-white px-3 py-2 text-base font-medium w-full text-left rounded-lg hover:bg-teal-700 transition-colors cursor-pointer"
              >
                Contacto
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
